import modafinilInitialQuestions from './initial/questions';
import modafinilFollowupQuestions from './followup/questions';

const ModafinilQuestions = [
  ...modafinilInitialQuestions,
  ...modafinilFollowupQuestions
];

export default ModafinilQuestions;

export type { ModafinilQuestionFieldAnswers } from './initial/questions';
export type { ModafinilFollowupQuestionFieldAnswers } from './followup/questions';
